import {
  ActionIcon,
  AppShell,
  Avatar,
  Box,
  Burger,
  Button,
  Group,
  Header,
  MediaQuery,
  Menu,
  Navbar,
  Text,
  Tooltip,
  UnstyledButton,
  useMantineTheme
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useAuth } from "../contexts/auth.context";
import RolesSelect from "../components/roles_select";
import { useAudio } from "../utility/util";
import routes from "../utility/routes";
import DownloadAppPage from "../pages/download_app";
import { useNavigate } from "react-router-dom";
import { FaBars, FaCompressArrowsAlt, FaExpand, FaRegArrowAltCircleLeft, FaSignOutAlt, FaUser } from "react-icons/fa";
import { useApp } from "../contexts/app.context";
import { useMediaQuery } from "@mantine/hooks";

export type LayoutProps = {
  children?: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  const theme = useMantineTheme();
  const notificationAudio = useAudio("/conversation-notification-2.wav");

  const {
    user: currentUser,
    currentCompany,
    hasPermission,
    userData,
    teams: userTeams,
    logout,
  } = useAuth();
  const { confirmDialog } = useApp();

  const lsOpened = localStorage.getItem("@satify/opened-sidebar");

  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 900px)');

  const [opened, setOpened] = useState(false);
  const [openedSidebar, setOpenedSidebar] = useState<boolean>(![null, undefined].includes(lsOpened) ? lsOpened === "true" : true);
  const [activeMenu, setActiveMenu] = useState(null);
  const [teams, setTeams] = React.useState<any[]>([]);
  const [filters, setFilters] = React.useState<any>({
    users: [],
    teams: [],
    period: [],
  });

  const navbarContent: {
    title: string;
    key: string;
    icon: React.ReactNode;
    url: string;
  }[] = routes
    .filter(
      (route) =>
        route.menu &&
        hasPermission(route) &&
        (!route.condition || route.condition({ user: userData?.user, currentCompany }))
    )
    .map(({ title, key, icon, url }) => ({ title, key, icon, url }));

  useEffect(() => {
    localStorage.setItem("@satify/opened-sidebar", openedSidebar.toString())
  }, [openedSidebar])

  if(["Cliente", "Motorista"].includes(userData?.user?.currentCompany?.role?.profile?.title)) return <DownloadAppPage />;

  return (
    <>
      <AppShell
        styles={{
          main: {
            background:
              theme.colors.gray[theme.colorScheme === "light" ? 0 : 9],
          },
        }}
        navbarOffsetBreakpoint="sm"
        asideOffsetBreakpoint="sm"
        fixed
        padding={0}
        navbar={
          <Navbar
            hiddenBreakpoint="sm"
            hidden={!opened}
            styles={{
              root: {
                // background: '#6a6a6a',
                top: 0,
                height: '100vh',
                // WebkitBoxShadow: '2px 0px 5px 0px #ff7400AA',
                // MozBoxShadow: '2px 0px 5px 0px #ff7400AA',
                // boxShadow: '2px 0px 5px 0px #ff7400AA',
                // border: 0,
                zIndex: 2,
                padding: 0,
                background: "linear-gradient(225deg, #ff7400 0%, #ff7400 100%), #ff7400"
              },
            }}
            width={{
              sm: openedSidebar ? 230 : 55,
              lg: openedSidebar ? 230 : 55,
            }}
          >
            <Navbar.Section grow p="xs" style={{ overflowY: "auto" }}>
              {openedSidebar
              ? <div style={{textAlign: 'center', padding: '40px 0 20px 0'}}><img
                src={"/logo.jpeg"}
                alt="Retainr"
                style={{ maxHeight: isMobile ? 60 : 80, maxWidth: isMobile ? '40%' : '60%', objectFit: 'contain' }}
              /></div>
              : <div style={{textAlign: 'center', padding: '10px 0 40px 0'}}><img
                src={"/icon.jpeg"}
                alt="Retainr"
                style={{ width: '50px', margin: -200, objectFit: 'contain' }}
              /></div>}

              {navbarContent.map((item, i) => (
                <Tooltip key={`${i}`} position="bottom" label={item.title}>
                  <UnstyledButton
                    mb="lg"
                    style={{width: '100%', borderRadius: 5, ...(i === activeMenu ? {background: '#FAFAFA'} : {})}}
                    onClick={() => {
                      setOpened(false);
                      navigate(item.url);
                      setActiveMenu(i)
                    }}
                  >
                    <Group key={item.key} align="center">
                      <ActionIcon
                        variant="light"
                        color="gray"
                        size="lg"
                        key={item.key}
                      >{item.icon}</ActionIcon>
                      {(openedSidebar || isMobile) && <Text size="sm" fw="bold" color={i === activeMenu ? "black" : "white"}>
                        {item.title}
                      </Text>}
                    </Group>
                  </UnstyledButton>
                </Tooltip>
              ))}
            </Navbar.Section>
            <Box p="xs">
              <Tooltip
                position="right"
                label={openedSidebar ? "Fechar menu" : "Expandir menu"}
              >
                <Box>
                {openedSidebar
                ? <Button
                  onClick={() => setOpenedSidebar(s => !s)}
                  fullWidth
                  variant="transparent"
                  size="xs"
                  style={{
                    color: "#fff",
                    cursor: "pointer",
                  }}
                  leftIcon={<FaCompressArrowsAlt />}
                >Fechar Menu</Button>
                : <ActionIcon
                  variant="transparent" style={{
                    color: "#fff",
                    cursor: "pointer",
                  }} onClick={() => setOpenedSidebar(s => !s)} size="lg"><FaExpand /></ActionIcon>}
                <Text></Text>
              </Box>
              </Tooltip>
            </Box>
          </Navbar>
        }
        header={ 
          <Header height={50} p="md" style={{
            left: isMobile ? 0 : openedSidebar ? 230 : 55,
            // backgroundImage: "linear-gradient(270deg, #F6F6F6 0%, #F6F6F6 100%)",
            // border: 0,
            // zIndex: 2,
            // WebkitBoxShadow: '2px 0px 5px 0px #ff7400AA',
            // MozBoxShadow: '2px 0px 5px 0px #ff7400AA',
            // boxShadow: '2px 0px 5px 0px #ff7400AA',
          }}>
            <div
              style={{ display: "flex", alignItems: "center", height: "100%" }}
            >
              {/* <img
                src="/icon-white.jpeg"
                alt="Satify"
                style={{
                  margin: -22,
                  height: 70,
                }}
              /> */}
              {/* <img src="/icon.svg" alt="Logo" style={{height: 30}} /> */}
              <MediaQuery largerThan="sm" styles={{ display: "none" }}>
                <Burger
                  opened={opened}
                  onClick={() => setOpened((o) => !o)}
                  size="sm"
                  color={theme.colors.gray[6]}
                  mr="xl"
                />
              </MediaQuery>

              <RolesSelect refresh={true} />

              <MediaQuery smallerThan="md" styles={{ display: "none" }}>
                <div style={{ flex: 1 }}></div>
              </MediaQuery>


              <ActionIcon
                onClick={() => {
                  confirmDialog(
                    { text: "Realmente deseja sair?" },
                    ({ confirmed }) => {
                      if (confirmed) logout();
                    }
                  );
                }}
                ml="xs"
                size="lg"
                color="orange"
                // variant="outline"
              ><FaSignOutAlt /></ActionIcon>

              {/* <ActionIcon><Avatar src="/icon.jpeg" /></ActionIcon> */}


              {/* <MediaQuery smallerThan="md" styles={{ display: 'none' }}>
              
            </MediaQuery> */}
            </div>
          </Header>
        }
      >
        <Box p="md">
          {children}
        </Box>
      </AppShell>
    </>
  );
};

export default Layout;
